import axios from 'axios'
import library from '../../../utils/Library'

export const getUserApplicationInstanceEAuthz = async (
  applicationInstanceId
) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') +
    `/getUserApplicationInstanceEAuthz?applicationInstanceId=${applicationInstanceId}&applicationCode=ME`

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
